module.exports = __webpack_public_path__ + "static/media/fr-FR.26579c65.md";